import React from "react";
import UserSessionCard from "./UserSessionCard";
import { deleteSelectedSessions, RenderUserSessionList, UserSessionListDialog } from "./common";
import { useFetch } from "../FetchProvider";
import { useRevalidator } from "react-router-dom";
import { Box } from "@mui/material";

// TODO: UserSessionList and UserSessionTable were refactored to be functional components, and to use
// useFetch. I do not think they are effecient, so one more iteration should be done in the future.
const UserSessionList: React.FC<{ rows: any[] }> = ({ rows }) => {
    const revalidator = useRevalidator();
    const [showDialog, setShowDialog] = React.useState(false);
    const [sessionDialogData, setSessionDialogData] = React.useState(null);

    const fetch = useFetch();

    const _deleteSelectedSessions = async () => {
        await deleteSelectedSessions([sessionDialogData["id"]], fetch);
        setShowDialog(false);
        revalidator.revalidate();
    };

    const _showSessionDialog = (data: any) => {
        setSessionDialogData(data);
        setShowDialog(true);
    };

    const _List = () => (
        <Box
            sx={{
                display: "grid",
                gridTemplateColumns: {
                    xs: "1fr",
                    sm: "repeat(2, 1fr)",
                    md: "repeat(3, 1fr)",
                },
                gap: 1,
            }}
        >
            {rows.map((session) => (
                <UserSessionCard key={session.id} session={session} onClick={() => _showSessionDialog(session)} />
            ))}
        </Box>
    );

    const _Dialog = () => (
        <UserSessionListDialog
            open={showDialog}
            data={sessionDialogData}
            hide={() => setShowDialog(false)}
            deleteSelectedSessions={_deleteSelectedSessions}
            disableDeleteCurrentSession={true}
        />
    );

    return <RenderUserSessionList Dialog={_Dialog} List={_List} rowsLength={rows.length} userSub={null} />;
};

export default UserSessionList;
